import './styles.css'

export const Snowfall = () => {
  return <div id="snow" />
}
